import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { getList } from "../../hooks/api/utils";
import GeojsonDataLayerMap from "../../components/visualizer/GeojsonViewer";
import IndicesViewer from "../../components/visualizer/IndicesViewer";
import RiskTypeViewer from "../../components/visualizer/RiskTypeViewer";

const OrderAnalysis = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, orderId } = location.state || {};
  const [analysis, setAnalysis] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);

  const handlePrev = () => {
    setActiveIndex((prev) =>
      prev === 0 ? analysis.historical_data.length - 1 : prev - 1
    );
  };

  const handleNext = () => {
    setActiveIndex((prev) =>
      prev === analysis.historical_data.length - 1 ? 0 : prev + 1
    );
  };

  const detail = async () => {
    await getList(
      `/orders/view-analysis/?item_id=${id}`,
      setLoading,
      setAnalysis
    );
  };

  useEffect(() => {
    if (id) {
      detail();
    } else {
      navigate("/orderlist");
    }
  }, [id]);

  const handleBack = () =>
    navigate(`/order-detail`, {
      state: { orderId },
    });

  return (
    <div className="rightContent">
      <div className="viewMain">
        <div className="row">
          <div className="col-md-12 bg-white left-col p-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h4>Order Detail</h4>
              <button
                className="btn btn-outline-secondary d-flex align-items-center gap-2"
                onClick={handleBack}
              >
                <FaArrowLeft /> Back to Orders
              </button>
            </div>
            <div className="position-relative">
              <h5 className="mt-5 mb-3">Order Analysis</h5>
              {!analysis && !loading ? (
                <div className="alert alert-warning">Analysis not found.</div>
              ) : (
                <>
                  {analysis?.historical &&
                  analysis.historical_data.length > 0 ? (
                    <>
                      {/* Header Month-Year + Prev/Next buttons */}
                      <div className=" prevNext">
                        <button
                          className="btn btn-light text-dark"
                          onClick={handlePrev}
                        >
                          ⟵ Prev
                        </button>

                        <h5 className="m-0 fw-bold text-center bg-light px-3 py-2 rounded">
                          {analysis.historical_data[activeIndex].month}{" "}
                          {analysis.historical_data[activeIndex].year}
                        </h5>

                        <button
                          className="btn btn-light text-dark"
                          onClick={handleNext}
                        >
                          Next ⟶
                        </button>
                      </div>

                      {/* Render Selected Historical Item */}
                      <div className="w-100">
                        {analysis.historical_data[activeIndex]?.metadata
                          ?.geojson && (
                          <GeojsonDataLayerMap
                            geojsonData={
                              analysis.historical_data[activeIndex]?.metadata
                                ?.geojson
                            }
                          />
                        )}

                        {analysis.historical_data[activeIndex]?.metadata
                          ?.indices && (
                          <IndicesViewer
                            result={
                              analysis.historical_data[activeIndex]?.metadata
                                ?.indices
                            }
                            coordinates={analysis?.coordinates}
                            image={analysis.historical_data[activeIndex]?.image}
                          />
                        )}
                      </div>
                    </>
                  ) : analysis?.risk_assessment &&
                  analysis?.risk_assessment_data ? (
                  <>
                    {/* Note: GeojsonViewer and IndicesViewer assume analysis.metadata is correctly structured */}
                    <RiskTypeViewer
                      data={analysis?.risk_assessment_data}
                      coordinates={analysis?.coordinates}
                      riskType={analysis?.risk_type}
                    />
                  </>
                ) : analysis?.metadata ? (
                    <>
                      {analysis?.metadata?.geojson && (
                        <GeojsonDataLayerMap
                          geojsonData={analysis?.metadata?.geojson}
                        />
                      )}
                      {analysis?.metadata?.indices && (
                        <IndicesViewer
                          image={analysis?.image}
                          result={analysis?.metadata?.indices}
                          coordinates={analysis?.coordinates}
                        />
                      )}
                    </>
                  ) : (
                    <div className="text-muted">
                      No analysis found for this order.
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderAnalysis;
